import { ArrowLeftIcon, ArrowRightIcon } from '@navi/web-ui/lib/icons';
import { IconButton } from '@navi/web-ui/lib/primitives';
import ModalDialog from '@navi/web-ui/lib/primitives/ModalDialog';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFieldVisitModalId } from 'src/reducers/commonSlice';
import { RootState } from 'src/store';
import { AnswerView, QuestionTags } from '../../interfaces/CommunicationHistory.type';
import styles from './index.module.scss';

interface FeedbackImageLocation {
  interactions: any;
}

const incrementCounterBy1 = (setter: React.Dispatch<React.SetStateAction<number>>) => () =>
  setter(counter => counter + 1);
const decrementCounterBy1 = (setter: React.Dispatch<React.SetStateAction<number>>) => () =>
  setter(counter => counter - 1);

const FeedbackImageLocation = ({ interactions }: FeedbackImageLocation) => {
  const fieldVisitModalId = useSelector((state: RootState) => state.common.fieldVisitModalId) || '';
  const dispatch = useDispatch();
  const [images, setImages] = React.useState<Array<string>>([]);
  const [counter, setCounter] = React.useState<number>(0);
  const filteredInteractions = interactions?.data?.find(
    (interaction: any) => interaction?.id === fieldVisitModalId
  );
  useEffect(() => {
    setCounter(0);
    if (filteredInteractions?.imageUrl?.length) {
      setImages(filteredInteractions?.imageUrl);
      return;
    }
    if (!filteredInteractions?.answerViews?.length) {
      setImages([]);
      return;
    }
    const imageContainingAnswers = filteredInteractions?.answerViews?.filter(
      (item: AnswerView) => item?.questionTag === QuestionTags.IMAGE_UPLOAD
    );
    if (!imageContainingAnswers?.length) {
      setImages([]);
      return;
    }
    const imageUrl = imageContainingAnswers?.map((item: AnswerView) => item?.inputText);
    setImages(imageUrl);
  }, [filteredInteractions]);
  const onClose = () => {
    dispatch(setFieldVisitModalId(''));
  };
  return (
    <ModalDialog
      onClose={onClose}
      open={!!fieldVisitModalId}
      contentClasses={styles.content}
      style={{ width: 960 }}
    >
      <IconButton
        disabled={counter <= 0}
        onClick={decrementCounterBy1(setCounter)}
        Icon={ArrowLeftIcon}
        size="large"
        variant="borderless-secondary"
      />
      <div className={styles.imageCounter}>
        <span className={styles.imageTxt}>Image</span>
        <span className={styles.imageNo}>
          {counter + 1}/{images.length}
        </span>
      </div>
      <div className={styles.imageContainer}>
        <img className={styles.feedBackImage} src={images[counter]} alt="image" />
      </div>
      <IconButton
        disabled={counter >= images.length - 1}
        onClick={incrementCounterBy1(setCounter)}
        Icon={ArrowRightIcon}
        size="large"
        variant="borderless-secondary"
      />
    </ModalDialog>
  );
};

export default FeedbackImageLocation;
